<template>
  <div class="bbr-canonical-exercise--detail">
    <main-app-bar>
      <template v-slot:title>
        {{ selected ? selected.name : 'Canonical Exercise' }}
      </template>
    </main-app-bar>

    <div class="mt-5 px-12 mb-10">
      <v-row v-if="selected">
        <v-col cols="12" class="d-flex align-center">
          <div class="text-h6">Linked Exercises ({{ exercises.length }})</div>
          <v-spacer />
          <div style="width: 360px" class="mr-3">
            <search-canonical-exercises-input
              v-model="targetId"
              label="Reassign selected to…"
              clearable
            />
          </div>
          <v-btn
            color="primary"
            depressed
            :loading="reassignBusy"
            :disabled="!canReassign"
            @click="reassign"
          >
            Reassign
          </v-btn>
        </v-col>

        <v-col cols="12">
          <v-simple-table>
            <thead>
              <tr>
                <th style="width: 48px">
                  <v-checkbox
                    :input-value="allSelected"
                    :indeterminate="someSelected"
                    hide-details
                    class="ma-0 pa-0"
                    @change="toggleAll"
                  />
                </th>
                <th>Exercise</th>
                <th>Coach</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="exercise in exercises" :key="exercise.id">
                <td>
                  <v-checkbox
                    v-model="selectedIds"
                    :value="exercise.id"
                    hide-details
                    class="ma-0 pa-0"
                  />
                </td>
                <td>{{ exercise.title }}</td>
                <td>{{ trainerName(exercise) }}</td>
              </tr>
            </tbody>
          </v-simple-table>

          <no-list
            v-if="!exercises.length"
            details="No exercises linked to this canonical exercise"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import MainAppBar from '@/layouts/shared/MainAppBar'
import NoList from '@/components/elements/NoList'
import SearchCanonicalExercisesInput from '@/components/elements/exercises/SearchCanonicalExercisesInput'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CanonicalExerciseDetail',

  components: {
    MainAppBar,
    NoList,
    SearchCanonicalExercisesInput,
  },

  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      selectedIds: [],
      targetId: null,
      reassignBusy: false,
    }
  },

  computed: {
    ...mapGetters({
      selected: 'canonicalExercises/selected',
    }),

    exercises() {
      return (this.selected && this.selected.exercises) || []
    },

    allSelected() {
      return (
        this.exercises.length > 0 &&
        this.selectedIds.length === this.exercises.length
      )
    },

    someSelected() {
      return this.selectedIds.length > 0 && !this.allSelected
    },

    canReassign() {
      return (
        this.selectedIds.length > 0 &&
        this.targetId &&
        Number(this.targetId) !== Number(this.id)
      )
    },
  },

  async mounted() {
    await this.fetch()
  },

  methods: {
    ...mapActions({
      getCanonicalExercise: 'canonicalExercises/getCanonicalExercise',
      reassignExercises: 'canonicalExercises/reassignExercises',
    }),

    fetch() {
      return this.getCanonicalExercise(this.id)
    },

    trainerName(exercise) {
      const trainer = exercise.trainer
      if (!trainer) return '—'
      return trainer.full_name || trainer.name || '—'
    },

    toggleAll(checked) {
      this.selectedIds = checked ? this.exercises.map((e) => e.id) : []
    },

    async reassign() {
      this.reassignBusy = true
      try {
        await this.reassignExercises({
          id: this.targetId,
          exerciseIds: this.selectedIds,
        })
        this.selectedIds = []
        this.targetId = null
        await this.fetch()
      } finally {
        this.reassignBusy = false
      }
    },
  },
}
</script>
